/* W3 speed-up loader for the theme's own marketing tags (script type=lazyload_int: LogRocket, Bing UET,
   HubSpot, Unbounce, ClickCease, Accessibly) plus the W3 lazy image / background / video helpers.
   Until 2026-10-04 this code was inlined on every page by snippets/wnw_header.liquid and snippets/wnw_footer.liquid
   (about 23 KB of HTML per view). Audit fixes applied with the move (group LAYOUT):
   - L1-7 / L7-7: Shopify's content_for_header is rendered verbatim in layout/theme.liquid again, so the
     trekkie / BOOMR re-execution helpers are gone (running them now would count every page view twice);
   - L3-5: a 4 s time fallback fires the gate for visitors who never move, touch or scroll, and the preload
     hints copy crossorigin and integrity from the script tag so the browser can reuse them;
   - L7-12: one cacheable asset, loaded with defer from snippets/wnw_header.liquid; the #w3_bg_load style it
     removes at the end stays inline there.
   Everything else is the vendor code as it shipped. */
var w3_lazy_load_by_px = 200,
    google_fonts_delay_load = 1e4,
    w3_mousemoveloadimg = !1,
    w3_page_is_scrolled = !1,
    w3_lazy_load_js = 1,
    w3_excluded_js = 0;
class w3_loadscripts {
    constructor(e) {
        this.triggerEvents = e, this.eventOptions = {
            passive: !0
        }, this.userEventListener = this.triggerListener.bind(this), this.lazy_trigger, this.style_load_fired, this.lazy_scripts_load_fired = 0, this.scripts_load_fired = 0, this.scripts_load_fire = 0, this.excluded_js = w3_excluded_js, this.w3_lazy_load_js = w3_lazy_load_js, this.w3_fonts = "undefined" != typeof w3_googlefont ? w3_googlefont : [], this.w3_styles = [], this.w3_scripts = {
            normal: [],
            async: [],
            defer: [],
            lazy: []
        }, this.allJQueries = []
    }
    user_events_add(e) {
        this.triggerEvents.forEach(t => window.addEventListener(t, e.userEventListener, e.eventOptions))
    }
    user_events_remove(e) {
        this.triggerEvents.forEach(t => window.removeEventListener(t, e.userEventListener, e.eventOptions))
    }
    triggerListener_on_load() {
        "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", this.load_resources.bind(this)) : this.load_resources()
    }
    triggerListener() {
        this.lazy_fallback_timer && clearTimeout(this.lazy_fallback_timer), this.user_events_remove(this), this.lazy_scripts_load_fired = 1, this.add_html_class("w3_user"), "loading" === document.readyState ? (document.addEventListener("DOMContentLoaded", this.load_style_resources.bind(this)), this.scripts_load_fire || document.addEventListener("DOMContentLoaded", this.load_resources.bind(this))) : (this.load_style_resources(), this.scripts_load_fire || this.load_resources())
    }
    async load_style_resources() {
        this.style_load_fired || (this.style_load_fired = !0, this.register_styles(), document.getElementsByTagName("html")[0].setAttribute("data-css", this.w3_styles.length), document.getElementsByTagName("html")[0].setAttribute("data-css-loaded", 0), this.preload_scripts(this.w3_styles), this.load_styles_preloaded())
    }
    async load_styles_preloaded() {
        setTimeout(function(e) {
            document.getElementsByTagName("html")[0].classList.contains("css-preloaded") ? e.load_styles(e.w3_styles) : e.load_styles_preloaded()
        }, 200, this)
    }
    async load_resources() {
        this.scripts_load_fired || (this.scripts_load_fired = !0, this.hold_event_listeners(), this.exe_document_write(), this.register_scripts(), this.add_html_class("w3_start"), "function" == typeof w3_events_on_start_js && w3_events_on_start_js(), this.preload_scripts(this.w3_scripts.normal), this.preload_scripts(this.w3_scripts.defer), this.preload_scripts(this.w3_scripts.async), await this.load_scripts(this.w3_scripts.normal), await this.load_scripts(this.w3_scripts.defer), await this.load_scripts(this.w3_scripts.async), await this.execute_domcontentloaded(), await this.execute_window_load(), window.dispatchEvent(new Event("w3-scripts-loaded")), this.add_html_class("w3_js"), "function" == typeof w3_events_on_end_js && w3_events_on_end_js(), this.lazy_trigger = setInterval(this.w3_trigger_lazy_script, 500, this))
    }
    async w3_trigger_lazy_script(e) {
        e.lazy_scripts_load_fired && (await e.load_scripts(e.w3_scripts.lazy), e.add_html_class("jsload"), clearInterval(e.lazy_trigger))
    }
    add_html_class(e) {
        document.getElementsByTagName("html")[0].classList.add(e)
    }
    register_scripts() {
        document.querySelectorAll("script[type=lazyload_int]").forEach(e => {
            e.hasAttribute("data-src") ? e.hasAttribute("async") && !1 !== e.async ? this.w3_scripts.async.push(e) : e.hasAttribute("defer") && !1 !== e.defer || "module" === e.getAttribute("data-w3-type") ? this.w3_scripts.defer.push(e) : this.w3_scripts.normal.push(e) : this.w3_scripts.normal.push(e)
        }), document.querySelectorAll("script[type=lazyload_ext]").forEach(e => {
            this.w3_scripts.lazy.push(e)
        })
    }
    register_styles() {
        document.querySelectorAll("link[data-href]").forEach(e => {
            this.w3_styles.push(e)
        })
    }
    async execute_script(e) {
        return await this.repaint_frame(), new Promise(t => {
            let s = document.createElement("script"),
                a;
            [...e.attributes].forEach(e => {
                let t = e.nodeName;
                "type" !== t && "data-src" !== t && ("data-w3-type" === t && (t = "type", a = e.nodeValue), s.setAttribute(t, e.nodeValue))
            }), e.hasAttribute("data-src") ? (s.setAttribute("src", e.getAttribute("data-src")), s.addEventListener("load", t), s.addEventListener("error", t)) : (s.text = e.text, t()), null !== e.parentNode && e.parentNode.replaceChild(s, e)
        })
    }
    async execute_styles(e) {
        var t;
        let s;
        return t = e, void((s = document.createElement("link")).href = t.getAttribute("data-href"), s.rel = "stylesheet", document.head.appendChild(s), t.parentNode.removeChild(t))
    }
    async load_scripts(e) {
        let t = e.shift();
        return t ? (await this.execute_script(t), this.load_scripts(e)) : Promise.resolve()
    }
    async load_styles(e) {
        let t = e.shift();
        return t ? (this.execute_styles(t), this.load_styles(e)) : "loaded"
    }
    async load_fonts(e) {
        var t = document.createDocumentFragment();
        e.forEach(e => {
            let s = document.createElement("link");
            s.href = e, s.rel = "stylesheet", t.appendChild(s)
        }), setTimeout(function() {
            document.head.appendChild(t)
        }, google_fonts_delay_load)
    }
    preload_scripts(e) {
        var t = document.createDocumentFragment(),
            s = 0,
            a = this;
        [...e].forEach(i => {
            let r = i.getAttribute("data-src"),
                n = i.getAttribute("data-href");
            if (r) {
                let d = document.createElement("link");
                d.href = r, d.rel = "preload", d.as = "script";
                // 2026-10-04 (audit L3-5): a preload is only reused when its credentials mode and integrity match the
                // script tag; without this LogRocket and friends were downloaded twice on every page.
                if (i.hasAttribute("crossorigin")) d.setAttribute("crossorigin", i.getAttribute("crossorigin") || "anonymous");
                if (i.hasAttribute("integrity")) d.setAttribute("integrity", i.getAttribute("integrity"));
                t.appendChild(d)
            } else if (n) {
                let l = document.createElement("link");
                l.href = n, l.rel = "preload", l.as = "style", s++, e.length == s && (l.dataset.last = 1), t.appendChild(l), l.onload = function() {
                    fetch(this.href).then(e => e.blob()).then(e => {
                        a.update_css_loader()
                    }).catch(e => {
                        a.update_css_loader()
                    })
                }, l.onerror = function() {
                    a.update_css_loader()
                }
            }
        }), document.head.appendChild(t)
    }
    update_css_loader() {
        document.getElementsByTagName("html")[0].setAttribute("data-css-loaded", parseInt(document.getElementsByTagName("html")[0].getAttribute("data-css-loaded")) + 1), document.getElementsByTagName("html")[0].getAttribute("data-css") == document.getElementsByTagName("html")[0].getAttribute("data-css-loaded") && document.getElementsByTagName("html")[0].classList.add("css-preloaded")
    }
    hold_event_listeners() {
        let e = {};

        function t(t, s) {
            ! function(t) {
                function s(s) {
                    return e[t].eventsToRewrite.indexOf(s) >= 0 ? "w3-" + s : s
                }
                e[t] || (e[t] = {
                    originalFunctions: {
                        add: t.addEventListener,
                        remove: t.removeEventListener
                    },
                    eventsToRewrite: []
                }, t.addEventListener = function() {
                    arguments[0] = s(arguments[0]), e[t].originalFunctions.add.apply(t, arguments)
                }, t.removeEventListener = function() {
                    arguments[0] = s(arguments[0]), e[t].originalFunctions.remove.apply(t, arguments)
                })
            }(t), e[t].eventsToRewrite.push(s)
        }

        function s(e, t) {
            let s = e[t];
            Object.defineProperty(e, t, {
                get: () => s || function() {},
                set(a) {
                    e["w3" + t] = s = a
                }
            })
        }
        t(document, "DOMContentLoaded"), t(window, "DOMContentLoaded"), t(window, "load"), t(window, "pageshow"), t(document, "readystatechange"), s(document, "onreadystatechange"), s(window, "onload"), s(window, "onpageshow")
    }
    hold_jquery(e) {
        let t = window.jQuery;
        Object.defineProperty(window, "jQuery", {
            get: () => t,
            set(s) {
                if (s && s.fn && !e.allJQueries.includes(s)) {
                    s.fn.ready = s.fn.init.prototype.ready = function(t) {
                        if (void 0 !== t) return e.scripts_load_fired ? e.domReadyFired ? t.bind(document)(s) : document.addEventListener("w3-DOMContentLoaded", () => t.bind(document)(s)) : t.bind(document)(s), s(document)
                    };
                    let a = s.fn.on;
                    s.fn.on = s.fn.init.prototype.on = function() {
                        if ("ready" == arguments[0]) {
                            if (this[0] !== document) return a.apply(this, arguments), this;
                            arguments[1].bind(document)(s)
                        }
                        if (this[0] === window) {
                            function e(e) {
                                return e.split(" ").map(e => "load" === e || 0 === e.indexOf("load.") ? "w3-jquery-load" : e).join(" ")
                            }
                            "string" == typeof arguments[0] || arguments[0] instanceof String ? arguments[0] = e(arguments[0]) : "object" == typeof arguments[0] && Object.keys(arguments[0]).forEach(t => {
                                Object.assign(arguments[0], {
                                    [e(t)]: arguments[0][t]
                                })[t]
                            })
                        }
                        return a.apply(this, arguments), this
                    }, e.allJQueries.push(s)
                }
                t = s
            }
        })
    }
    async execute_domcontentloaded() {
        this.domReadyFired = !0, await this.repaint_frame(), document.dispatchEvent(new Event("w3-DOMContentLoaded")), await this.repaint_frame(), window.dispatchEvent(new Event("w3-DOMContentLoaded")), await this.repaint_frame(), document.dispatchEvent(new Event("w3-readystatechange")), await this.repaint_frame(), document.w3onreadystatechange && document.w3onreadystatechange()
    }
    async execute_window_load() {
        await this.repaint_frame(), setTimeout(function() {
            window.dispatchEvent(new Event("w3-load"))
        }, 100), await this.repaint_frame(), window.w3onload && window.w3onload(), await this.repaint_frame(), this.allJQueries.forEach(e => e(window).trigger("w3-jquery-load")), window.dispatchEvent(new Event("w3-pageshow")), await this.repaint_frame(), window.w3onpageshow && window.w3onpageshow()
    }
    exe_document_write() {
        let e = new Map;
        document.write = document.writeln = function(t) {
            let s = document.currentScript,
                a = document.createRange(),
                i = s.parentElement,
                r = e.get(s);
            void 0 === r && (r = s.nextSibling, e.set(s, r));
            let n = document.createDocumentFragment();
            a.setStart(n, 0), n.appendChild(a.createContextualFragment(t)), i.insertBefore(n, r)
        }
    }
    async repaint_frame() {
        return new Promise(e => requestAnimationFrame(e))
    }
    static execute() {
        let e = new w3_loadscripts(["keydown", "mousemove", "touchmove", "touchstart", "touchend", "wheel"]);
        e.load_fonts(e.w3_fonts), e.user_events_add(e), e.excluded_js || e.hold_jquery(e), e.w3_lazy_load_js || (e.scripts_load_fire = 1, e.triggerListener_on_load());
        // 2026-10-04 (audit L3-5): visitors who never move, touch or scroll (bounces, background tabs, Lighthouse)
        // still get the marketing tags after 4 s instead of never.
        e.lazy_fallback_timer = setTimeout(function() {
            e.triggerListener()
        }, 4000);
        let t = setInterval(function e(s) {
            null != document.body && (document.body.getBoundingClientRect().top < -30 && s.triggerListener(), clearInterval(t))
        }, 500, e)
    }
}
setTimeout(function(){
w3_loadscripts.execute();
},1000);

/* Formerly snippets/wnw_footer.liquid: lazy images, background images, iframes and videos. */
    w3_bglazyload = 1;
    (function() {
        var img = new Image();
        img.onload = function() {
            w3_hasWebP = !!(img.height > 0 && img.width > 0);
        };
        img.onerror = function() {
            w3_hasWebP = false;
        };
    })();
    
    function w3_events_on_end_js() {
        const lazy_bg_style = document.getElementById("w3_bg_load");
        lazy_bg_style.remove();
        w3_bglazyload = 0;
        lazyloadimages(0);
        if(window.site_nav_link_burger == false) {
            jQuery("button.site-header__menu.js-mobile-nav-toggle.mobile-nav--open").click();
            window.site_nav_link_burger = false;
        }
    }
    
    function w3_start_img_load() {
        var top = this.scrollY;
        lazyloadimages(top);
        lazyloadiframes(top);
    }
    
    function w3_events_on_start_js() {
        var lazyvideos = document.getElementsByTagName("videolazy");
        convert_to_video_tag(lazyvideos);
        w3_start_img_load();
    }
    window.addEventListener("scroll", function(event) {
        w3_start_img_load();
    }, {
        passive: true
    });
    var w3_is_mobile = (window.matchMedia("(max-width: 767px)").matches ? 1 : 0);
    var win_width = screen.availWidth;
    var bodyRectMain = {};
    bodyRectMain.top = 1;
    setInterval(function() {
        lazyloadiframes(top);
    }, 8000);
    setInterval(function() {
        lazyloadimages(0);
    }, 3000);
    document.addEventListener("click", function() {
        lazyloadimages(0);
    });
    
    function getDataUrl(img1, width, height) {
        var myCanvas = document.createElement("canvas");
        var ctx = myCanvas.getContext("2d");
        var img = new Image();
        myCanvas.width = parseInt(width);
        myCanvas.height = parseInt(height);
        ctx.drawImage(img, 0, 0);
        img1.src = myCanvas.toDataURL("image/png");
    }
    
    function lazyload_img(imgs, bodyRect, window_height, win_width) {
        for (var i = 0; i < imgs.length; i++) {
            if (imgs[i].getAttribute("data-class") == "LazyLoad") {
                var elem = imgs[i],
                    elemRect = imgs[i].getBoundingClientRect();
                if (elemRect.top != 0 && (elemRect.top - (window_height - bodyRect.top)) < w3_lazy_load_by_px) {
                    compStyles = window.getComputedStyle(imgs[i]);
                    if (compStyles.getPropertyValue("opacity") == 0) {
                        continue;
                    }
                    if (elem.tagName == "IFRAMELAZY") {
                        var elem = document.createElement("iframe");
                        var index;
                        for (index = imgs[i].attributes.length - 1; index >= 0; --index) {
                            elem.attributes.setNamedItem(imgs[i].attributes[index].cloneNode());
                        }
                        imgs[i].parentNode.replaceChild(elem, imgs[i]);
                    }
                    var src = elem.getAttribute("data-src") ? elem.getAttribute("data-src") : elem.src;
                    if (w3_is_mobile && elem.getAttribute("data-mob-src")) {
                        src = elem.getAttribute("data-mob-src");
                    }
                    var srcset = elem.getAttribute("data-srcset") ? elem.getAttribute("data-srcset") : "";
                    if (!srcset) {
                        elem.onload = function() {
                            this.setAttribute("data-done", "Loaded");
                            if (typeof(w3speedup_after_iframe_img_load) == "function") {
                                w3speedup_after_iframe_img_load(this);
                            }
                        }
                        elem.onerror = function() {
                            if (this.getAttribute("data-mob-src") && w3_is_mobile && this.getAttribute("data-src")) {
                                this.src = this.getAttribute("data-src");
                            }
                        }
                    }
                    elem.src = src;
                    if (srcset != null & srcset != "") {
                        elem.srcset = srcset;
                    }
                    delete elem.dataset.class;
                }
            }
        }
    }
    
    function w3_load_dynamic_blank_img(imgs) {
        for (var i = 0; i < imgs.length; i++) {
            if (imgs[i].getAttribute("data-class") == "LazyLoad") {
                var blanksrc = imgs[i].src;
                if (typeof(blanksrc) != "undefined" && blanksrc.indexOf("data:") == -1) {
                    if (imgs[i].getAttribute("width") != null && imgs[i].getAttribute("height") != null) {
                        var width = parseInt(imgs[i].getAttribute("width"));
                        var height = parseInt(imgs[i].getAttribute("height"));
                        getDataUrl(imgs[i], width, height);
                    }
                }
            }
        }
    }
    
    function convert_to_video_tag(imgs) {
        const t = imgs.length > 0 ? imgs[0] : "";
        if (t) {
            delete imgs[0];
            var newelem = document.createElement("video");
            var index;
            for (index = t.attributes.length - 1; index >= 0; --index) {
                newelem.attributes.setNamedItem(t.attributes[index].cloneNode());
            }
            newelem.innerHTML = t.innerHTML;
            t.parentNode.replaceChild(newelem, t);
            if (typeof(newelem.getAttribute("data-poster")) == "string") {
                newelem.setAttribute("poster", newelem.getAttribute("data-poster"));
            }
            convert_to_video_tag(imgs);
        }
    }
    
    function lazyload_video(imgs, bodyRect, top, window_height, win_width) {
        for (var i = 0; i < imgs.length; i++) {
            var elem = imgs[i],
                elemRect = imgs[i].getBoundingClientRect();
            if (elemRect.top != 0 && (elemRect.top - (window_height - bodyRect.top)) < w3_lazy_load_by_px) {
                if (typeof(imgs[i].getElementsByTagName("source")[0]) == "undefined") {
                    lazyload_video_source(imgs[i], top, window_height, win_width, elemRect, bodyRect);
                } else {
                    var sources = imgs[i].getElementsByTagName("source");
                    for (var j = 0; j < sources.length; j++) {
                        var source = sources[j];
                        lazyload_video_source(source, top, window_height, win_width, elemRect, bodyRect);
                    }
                }
            }
        }
    }
    
    function lazyload_video_source(source, top, window_height, win_width, elemRect, bodyRect) {
        if (typeof source != "undefined" && source.getAttribute("data-class") == "LazyLoad") {
            if (elemRect.top != 0 && (elemRect.top - (window_height - bodyRect.top)) < w3_lazy_load_by_px) {
                var src = source.getAttribute("data-src") ? source.getAttribute("data-src") : source.src;
                var srcset = source.getAttribute("data-srcset") ? source.getAttribute("data-srcset") : "";
                if (source.srcset != null & source.srcset != "") {
                    source.srcset = srcset;
                }
                if (typeof(source.getElementsByTagName("source")[0]) == "undefined") {
                    if (source.tagName == "SOURCE") {
                        source.parentNode.src = src;
                        source.parentNode.load();
                        if (source.parentNode.getAttribute("autoplay") !== null) {
                            source.parentNode.play();
                        }
                    } else {
                        source.src = src;
                        source.load();
                        if (source.getAttribute("autoplay") !== null) {
                            source.play();
                        }
                    }
                } else {
                    source.parentNode.src = src;
                }
                delete source.dataset.class;
                source.setAttribute("data-done", "Loaded");
            }
        }
    }
    
    function lazyload_imgbgs(imgbgs, bodyRect, window_height, win_width) {
        for (var i = 0; i < imgbgs.length; i++) {
            var elem = imgbgs[i],
                elemRect = imgbgs[i].getBoundingClientRect(),
                offset = elemRect.top - bodyRect.top;
            if ((elemRect.top - (window_height - bodyRect.top)) < w3_lazy_load_by_px) {
                elem.classList.add("w3_bg");
            }
        }
    }
    
    function lazyloadimages(top) {
        var imgs = document.querySelectorAll("img[data-class=LazyLoad]");
        var imgbgs = document.querySelectorAll("div:not(.w3_js), section:not(.w3_js), iframelazy:not(.w3_js)");
        var sources = document.getElementsByTagName("video");
        var sources_audio = document.getElementsByTagName("audio");
        var bodyRect = document.body.getBoundingClientRect();
        var window_height = window.innerHeight;
        var win_width = screen.availWidth;
        if (typeof(load_dynamic_img) != "undefined") {
            w3_load_dynamic_blank_img(imgs);
            delete load_dynamic_img;
        }
        if (w3_bglazyload && ((bodyRect.top < 50 && bodyRectMain.top == 1) || Math.abs(bodyRectMain.top) - Math.abs(bodyRect.top) < -50 || Math.abs(bodyRectMain.top) - Math.abs(bodyRect.top) > 50)) {
            bodyRectMain = bodyRect;
            lazyload_imgbgs(imgbgs, bodyRect, window_height, win_width);
        }
        lazyload_img(imgs, bodyRect, window_height, win_width);
        lazyload_video(sources, bodyRect, top, window_height, win_width);
        lazyload_video(sources_audio, bodyRect, top, window_height, win_width);
    }
    lazyloadimages(0);
    
    function lazyloadiframes(top) {
        var bodyRect = document.body.getBoundingClientRect();
        var window_height = window.innerHeight;
        var win_width = screen.availWidth;
        var iframes = document.querySelectorAll("iframelazy[data-class=LazyLoad]");
        lazyload_img(iframes, bodyRect, window_height, win_width);
    }
